import { Box, Typography } from "@mui/material";

const CustomizedTooltip = (props) => {
  const { active, payload, units } = props;

  const dataKey = payload?.[0]?.dataKey;
  const value = payload?.[0]?.payload?.[dataKey];

  if (!active || !value) return null;

  return (
    <Box
      sx={{
        display: "flex",
        flexDirection: "column",
        padding: "8px",
        backgroundColor: "#FFF",
        border: "1px solid #000",
        borderRadius: "4px",
        alignItems: "center",
      }}
    >
      <Typography fontSize="14px">
        {value}
        {units !== "%" ? ` ${units}` : units}
      </Typography>
    </Box>
  );
};

export default CustomizedTooltip;
